const s = {
  name: "Fingerprint",
  dimensions: { width: 34, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34 40" style="enable-background:new 0 0 34 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M32,23c0,3-0.9,5.8-2.4,8.2l1.4,1.4c1.9-2.7,3-6.1,3-9.6v-4h-2V23z"/>
		<path class="st0" d="M28.4,32.8c-2.5,3-6.2,4.9-10.4,5.2v2c4.7-0.3,8.9-2.5,11.8-5.8L28.4,32.8z"/>
		<path class="st0" d="M2,23H0c0,9,7.1,16.4,16,17v-2C8.2,37.4,2,30.9,2,23z"/>
		<path class="st0" d="M18,0c-0.3,0-0.7,0-1,0s-0.7,0-1,0C7.1,0.5,0,8,0,17v4h2v-4C2,9.1,8.2,2.6,16,2c0.3,0,0.7,0,1,0s0.7,0,1,0
			c4.1,0.3,7.8,2.2,10.4,5.2l1.4-1.4C26.9,2.5,22.7,0.3,18,0z"/>
		<path class="st0" d="M31,7.4l-1.4,1.4C31.1,11.2,32,14,32,17h2C34,13.4,32.9,10.1,31,7.4z"/>
		<path class="st0" d="M4,17c0-2.5,0.7-4.8,1.9-6.7l1.5,1.5C6.5,13.3,6,15.1,6,17v4H4V17z"/>
		<path class="st0" d="M8.5,10L7.1,8.6C9.2,6,12.4,4.3,16,4v2C13,6.3,10.3,7.8,8.5,10z"/>
		<path class="st0" d="M18,6.1V4c3.6,0.3,6.8,2,9,4.6L25.5,10C23.7,7.8,21,6.3,18,6.1z"/>
		<path class="st0" d="M26.7,11.7l1.5-1.5c1.2,2,1.9,4.3,1.9,6.7v6c0,2.4-0.7,4.8-1.9,6.7l-1.5-1.5c0.9-1.6,1.3-3.4,1.3-5.2v-6
			C28,15.1,27.5,13.3,26.7,11.7z"/>
		<path class="st0" d="M4,23h2c0,1.9,0.5,3.7,1.3,5.2l-1.5,1.5C4.7,27.7,4,25.5,4,23z"/>
		<path class="st0" d="M18,33.9c3-0.3,5.7-1.8,7.5-4l1.4,1.4c-2.2,2.6-5.4,4.3-9,4.6c-0.3,0-0.7,0-1,0s-0.7,0-1,0
			c-3.6-0.3-6.8-2-8.9-4.6l1.4-1.4c1.8,2.2,4.5,3.7,7.5,4c0.3,0,0.7,0,1,0S17.7,34,18,33.9z"/>
		<path class="st0" d="M26,19v-2c0-5-4-9-9-9c-2.9,0-5.4,1.4-7.1,3.5l1.4,1.4c1.3-1.8,3.3-2.9,5.7-2.9c3.9,0,7,3.1,7,7v2H26z"/>
		<path class="st0" d="M16,29.9c-0.6-0.1-1.1-0.2-1.6-0.4C11.7,28.4,10,25.9,10,23v-6c0-0.8,0.1-1.5,0.4-2.2l-1.5-1.5
			C8.3,14.4,8,15.7,8,17v6c0,3.7,2.2,7,5.7,8.4c0.7,0.3,1.4,0.5,2.2,0.6c0.1,0,0.2,0,0.2,0V29.9z"/>
		<path class="st0" d="M26,21v2c0,4.6-3.5,8.4-8,8.9v-2c3.4-0.5,6-3.4,6-6.9v-2H26z"/>
		<path class="st0" d="M12,23c0,2.8,2.2,5,5,5s5-2.2,5-5v-4h-2v4c0,1.6-1.4,3-3,3s-3-1.4-3-3H12z"/>
		<path class="st0" d="M14,21h-2v-4c0-2.8,2.2-5,5-5s5,2.2,5,5h-2c0-1.7-1.4-3-3-3s-3,1.4-3,3V21z"/>
		<path class="st0" d="M16,24v-8h2v8H16z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Fingerprint
};
